/** @jsx jsx */
import { Button } from "@eworkit/iris";
import React, { PropsWithChildren } from "react";
import {
  Menu as ReakitMenu,
  MenuBar as ReakitMenuBar,
  MenuButton as ReakitMenuButton,
  MenuItem as ReakitMenuItem,
  MenuSeparator as ReakitMenuSeparator,
} from "reakit/Menu";
import { jsx } from "theme-ui";

import { menuBarStyles, menuSeparatorStyles, menuStyles } from "./config";

export interface MenuProps extends React.ComponentPropsWithoutRef<typeof ReakitMenu> {}
export interface MenuBarProps extends React.ComponentPropsWithoutRef<typeof ReakitMenuBar> {}

export const Menu = React.forwardRef<HTMLDivElement, PropsWithChildren<MenuProps>>((props, ref) => {
  return (
    <ReakitMenu data-component="menu" sx={menuStyles} {...props} ref={ref}>
      {props.children}
    </ReakitMenu>
  );
});

export const MenuBar = React.forwardRef<HTMLDivElement, PropsWithChildren<MenuBarProps>>(
  ({ children, ...rest }, ref) => {
    return (
      <ReakitMenuBar data-component="menu-bar" sx={menuBarStyles} {...rest} ref={ref}>
        {children}
      </ReakitMenuBar>
    );
  },
);

export const MenuItem = React.forwardRef((props: any, ref) => {
  return (
    <ReakitMenuItem as={Button} variant="ghost" data-component="menu-item" {...props} ref={ref}>
      {props.children}
    </ReakitMenuItem>
  );
});

export const MenuButton = React.forwardRef((props: any, ref) => {
  return (
    <ReakitMenuButton data-component="menu-button" {...props} ref={ref}>
      {props.children}
    </ReakitMenuButton>
  );
});

export const MenuSeparator = React.forwardRef((props: any, ref) => {
  return <ReakitMenuSeparator data-component="menu-separator" {...props} ref={ref} sx={menuSeparatorStyles} />;
});
